import { useQuery } from '@apollo/client/react';
import { STAFF_ACTIVITY_LOG } from '@staff-app/graphql-client';

/** One display-ready Activity Log row (mapped server-side from staff_audit_log). */
export interface ActivityLogEntry {
  id: string;
  /** Display time in CST, e.g. "2026-06-12 09:33:52 CST". */
  time: string;
  tool: string;
  submittedBy: string;
  summary: string;
  /** 'Success' | 'Failed'. */
  status: string;
  detail?: string | null;
}

/** A page of Activity Log rows + total count + the full tool list (for the filter). */
export interface ActivityLogPage {
  items: ActivityLogEntry[];
  total: number;
  tools: string[];
}

interface ActivityLogVars {
  offset?: number;
  limit?: number;
  search?: string;
  tool?: string;
}

/**
 * Activity Log (root-only) — staff_audit_log rows, newest first, paginated
 * (offset/limit) with a total count. `search` + `tool` filter SERVER-SIDE across
 * ALL history (not just the current page).
 */
export function useActivityLog(vars: ActivityLogVars) {
  return useQuery<{ staffActivityLog: ActivityLogPage }, ActivityLogVars>(STAFF_ACTIVITY_LOG, {
    variables: vars,
    fetchPolicy: 'cache-and-network',
  });
}
